import styled from 'styled-components'
import colors from 'globals/colors'
import measures from 'globals/measures'
import { Card } from 'components'

export const DayForwardings = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
`

export const DayForwardingsHeader = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: ${measures.mobileThreshold}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const ForwardingCard = styled(Card)`
  line-height: 28px;

  & > svg {
    margin-right: 7px;

    & .color-stroke {
      stroke: ${colors.waterBlue};
    }
  }

  & > b {
    color: ${colors.waterBlue};
  }

  & > span {
    font-weight: 600;
  }

  & > a {
    color: ${colors.darkGrey};
    font-weight: 600;
    text-decoration: underline;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      color: ${colors.darkGrey};
    }
  }
`
